module.exports = __webpack_public_path__ + "img/es-ES-add-to-google-wallet.8f4092b.svg";